module.exports = __webpack_public_path__ + "assets/img/25-m.01cc97e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/25-m.jpg
// module id = RE5C
// module chunks = 0